import { render, staticRenderFns } from "./marketing-pad.vue?vue&type=template&id=40820d81&scoped=true&"
import script from "./marketing-pad.vue?vue&type=script&lang=js&"
export * from "./marketing-pad.vue?vue&type=script&lang=js&"
import style0 from "./marketing-pad.vue?vue&type=style&index=0&id=40820d81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40820d81",
  null
  
)

export default component.exports